import { jsx as s } from "react/jsx-runtime";
import { c as i } from "../../../index-Cu0xwYjD.js";
import { P as n } from "../P/P.js";
import { s as t } from "../../../Skeleton.module-BVp5AJxK.js";
const f = ({ lines: o = 1, ...a }) => {
  const r = [];
  for (let e = 1; e <= o; e++)
    r.push(
      /* @__PURE__ */ s(
        "span",
        {
          "aria-hidden": "true",
          "aria-busy": "true",
          className: i(t.skeleton, t.text)
        },
        `line-${e}`
      )
    );
  return /* @__PURE__ */ s(n, { ...a, children: r });
};
export {
  f as SkeletonText
};
